import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CombinationSelector from './CombinationSelector';
import CombinationAssignmentsPanel from './CombinationAssignmentsPanel';
import { AppBar, Box, Stack, Toolbar, Typography } from '@mui/material';
import LocationAssignmentSelector from './LocationAssignmentSelector';
import LocationAssignmentsPanel from './LocationAssignmentsPanel';
import ModalSpinner from '../../../../modules/components/ModalSpinner';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
CustomTabPanel.defaultProps = {
  children: null,
};

const Assignments = ({ user, reviewGroupTerritories, permitTypes }) => {
  const { updatingTerritoryAssignment, updatingPermitTypeLocationAssignments } = useSelector(
    (state) => state.admin
  );

  const [tabValue, setTabValue] = React.useState(0);

  React.useEffect(() => {
    if (tabValue > reviewGroupTerritories.length - 1) {
      setTabValue(0);
    }
  }, [reviewGroupTerritories, tabValue]);

  return (
    <Box>
      <ModalSpinner open={updatingTerritoryAssignment || updatingPermitTypeLocationAssignments} />
      <AppBar position="static" color="secondary">
        <Toolbar variant="dense">
          <Typography variant="h6" color="inherit" component="div">
            Review Assignment
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          marginTop: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'inline' }}>
            <Tabs
              value={tabValue}
              onChange={(e, newValue) => setTabValue(newValue)}
              aria-label="basic tabs example"
            >
              {reviewGroupTerritories.map((rgt, idx) => {
                return <Tab label={rgt.reviewGroupName} key={idx} />;
              })}
            </Tabs>
          </Box>
          <Box>
            {reviewGroupTerritories.map((rgt, idx) => {
              return (
                tabValue === idx && (
                  <Box key={idx} sx={{ marginTop: '10px' }}>
                    {rgt.reviewGroupValue === 'PERMITMANAGER' && (
                      <Stack direction="row" spacing={4}>
                        <Box sx={{ width: '50%' }}>
                          <CombinationSelector
                            user={user}
                            reviewGroupTerritories={rgt}
                            permitTypes={permitTypes}
                          />
                        </Box>
                        <Box sx={{ width: '50%' }}>
                          <CombinationAssignmentsPanel
                            user={user}
                            permitTypes={permitTypes}
                            territories={rgt.territories}
                          />
                        </Box>
                      </Stack>
                    )}
                    {(rgt.reviewGroupValue === 'ENGINEERING' ||
                      rgt.reviewGroupValue === 'RAILROAD') && (
                      <Stack direction="row" spacing={4}>
                        <Box sx={{ width: '50%' }}>
                          <LocationAssignmentSelector user={user} reviewGroupTerritories={rgt} />
                        </Box>
                        <Box sx={{ width: '50%' }}>
                          <LocationAssignmentsPanel user={user} reviewGroupTerritories={rgt} />
                        </Box>
                      </Stack>
                    )}
                  </Box>
                )
              );
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

Assignments.propTypes = {
  user: PropTypes.object.isRequired,
  reviewGroupTerritories: PropTypes.array.isRequired,
  permitTypes: PropTypes.array.isRequired,
};

export default Assignments;
